export var _tag = `
<span class='badge {{#unless display_tags}}d-none{{/unless}}' style="background-color: {{bg_color}}"><small style="color: {{text_color}}">{{#if course}}<i class="fa fa-book fa-fw"/>{{/if}}{{text}}</small></span>
`;
